module.exports = __webpack_public_path__ + "static/media/CloseIcon.4e6ff220.svg";